var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6352 4.4596L18.3741 5.2698L19.113 4.4596C20.9376 2.45885 23.4488 1.33398 26.0961 1.33398C31.3804 1.33398 35.7482 5.82059 35.7482 11.4179C35.7482 13.9119 34.7823 16.3894 32.8873 18.585C29.6996 22.2776 20.1757 32.2621 18.3741 34.1472C16.5729 32.2625 7.04855 22.2775 3.86101 18.585C1.96595 16.3894 1 13.9119 1 11.4179C1 5.82059 5.36786 1.33398 10.6521 1.33398C13.2994 1.33398 15.8106 2.45885 17.6352 4.4596Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.0ff9d9448695e4dc0d3d7cf229d9b8f6.svg";
export { ForwardRef as ReactComponent };